import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="12 11 49 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="#2f0f4d"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.6132 19.6664V19.7026C60.6132 19.7473 60.627 19.7782 60.646 19.8208L60.6461 19.8209C60.6579 19.8473 60.6717 19.8781 60.6855 19.9195V35.2162C60.6855 35.7948 60.0346 36.1926 59.5283 35.9033L46.763 29.0324L37.2885 34.8545C36.963 35.0354 36.5652 35.0354 36.2398 34.8545L26.7652 29.0324L14 35.9033C13.4575 36.1926 12.8428 35.7948 12.8428 35.2162V19.9195C12.8428 19.8834 12.8518 19.8472 12.8609 19.8111C12.8699 19.7749 12.8789 19.7387 12.8789 19.7026V19.6664C12.9513 19.4494 13.0959 19.2325 13.3491 19.0878L26.2951 12.1085H26.3313C26.4036 12.0723 26.476 12.0362 26.5483 12.0362C26.8376 11.9638 27.0907 12 27.3077 12.1446L36.746 17.9668L46.1844 12.1446C46.4014 12.0362 46.6907 11.9638 46.9438 12.0362C47.0161 12.0362 47.0885 12.0723 47.1608 12.1085H47.1969L60.143 19.0878C60.3962 19.1963 60.5408 19.4133 60.6132 19.6664ZM57.6478 19.9557L47.7032 14.6037V26.0671L57.6478 19.9557ZM25.7889 14.6037L15.8442 19.9557L25.7889 26.1033V14.6037ZM14.8317 21.6915V33.1911L24.7763 27.8029L14.8317 21.6915ZM27.7778 27.2966L36.746 32.8295L45.7143 27.2966V14.7122L37.2162 19.9557C36.9269 20.1365 36.5652 20.1365 36.2759 19.9557L27.7778 14.7122V27.2966ZM58.6242 21.6915L48.6796 27.8029L58.6242 33.1911V21.6915Z"
      />
    </svg>
  );
};

export default LogoIcon;
